import LightGallery from 'lightgallery/react';
import './Gal.css';

// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-autoplay.css';
import 'lightgallery/css/lg-fullscreen.css';
import 'lightgallery/css/lg-share.css';
import 'lightgallery/css/lg-rotate.css';


// import plugins if you need
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgAutoplay from 'lightgallery/plugins/autoplay'
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgShare from 'lightgallery/plugins/share';
import lgRotate from 'lightgallery/plugins/rotate';

const images = [
    { src: "images/Ba07/Ba 7 (2).jpg", alt: "1" },
    { src: "images/Ba07/Ba 7 (3).jpg", alt: "2" },
    { src: "images/Ba13/BA 13 (1).jpg", alt: "3" },
    { src: "images/Ba13/BA 13 (2).jpg", alt: "4" },
    { src: "images/Ba15/BA 15 (1).jpg", alt: "5" },
    { src: "images/Ba15/BA 15 (2).jpg", alt: "6" },
    { src: "images/Ba15/BA 15 (3).jpg", alt: "7" },
    { src: "images/Ba17/BA 17 (5).jpg", alt: "8" },
    { src: "images/Ba17/BA 17 (6).jpg", alt: "9" },
    { src: "images/Ba17/BA 17 (7).jpg", alt: "10" },
    { src: "images/Ba17/BA 17 (8).jpg", alt: "11" },
    { src: "images/Ba17/BA 17 (9).jpg", alt: "12" },
    { src: "images/Ba17/BA 17 (10).jpg", alt: "13" },
    { src: "images/Ba17/BA 17 (11).jpg", alt: "14" },
    { src: "images/Ba17/BA 17 (12).jpg", alt: "15" },
    { src: "images/Ba17/BA 17 (13).jpg", alt: "16" },
    { src: "images/Ba19/BA 19 (4).jpg", alt: "17" },
    { src: "images/Ba19/BA 19 (5).jpg", alt: "18" },
    { src: "images/Ba19/BA 19 (6).png", alt: "19" },
    { src: "images/Ba19/BA 19 (7).jpg", alt: "20" },
    { src: "images/Ba19/BA 19 (8).png", alt: "21" },
    { src: "images/Ba19/BA 19 (9).jpg", alt: "22" },
    { src: "images/Ba19/BA 19 (10).jpg", alt: "23" },
    { src: "images/Ba19/BA 19 (11).png", alt: "24" },
    { src: "images/Ba19/BA 19 (12).png", alt: "25" },
    { src: "images/Ba21/BA 21 (19).jpg", alt: "26" },
    { src: "images/Ba21/BA 21 (20).jpg", alt: "27" },
    { src: "images/Ba21/BA 21 (21).jpg", alt: "28" },
    { src: "images/Ba21/BA 21 (22).jpg", alt: "29" },
    { src: "images/Ba21/BA 21 (23).jpg", alt: "30" },
    { src: "images/Ba23/BA 23 (14).jpg", alt: "31" },
    { src: "images/Ba23/BA 23 (15).jpg", alt: "32" },
    { src: "images/Ba23/BA 23 (16).jpg", alt: "33" },
    { src: "images/Ba23/BA 23 (17).jpg", alt: "34" },
    { src: "images/Ba27/BA 27 (15).jpg", alt: "35" },
    { src: "images/Ba27/BA 27 (16).jpg", alt: "36" },
    { src: "images/Ba27/BA 27 (17).jpg", alt: "37" },
    { src: "images/Ba27/BA 27 (18).jpg", alt: "38" },
    { src: "images/Ba27/BA 27 (19).jpg", alt: "39" },
   
    
]

function Construction() {
    const onInit = () => {
        console.log('lightGallery has been initialized');
    };
    return (
        <div className="gallery-container">
        <h1>Construction</h1>
       <p className='about'> We offer comprehensive construction services, managing every phase of the building process from start to finish. Our experienced team ensures high-quality workmanship, and compliance with safety standards.
       </p>  
            <LightGallery
                onInit={onInit}
                speed={500}
                plugins={[lgThumbnail, lgZoom, lgAutoplay, lgFullscreen, lgRotate, lgShare]}
            >

                {images.map((image, index) => {
                    return (
                        <a href={image.src} key={index}>
                            <img alt={image.alt} src={image.src} />
                        </a>
                    )
                })}


            </LightGallery>
        </div>
    );
}
export default Construction;
